import {Component, OnInit, Input, ViewContainerRef, SimpleChanges, Inject, NgModule} from '@angular/core';
import {Table} from "../../shared/model/table";
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {Overlay} from "angular2-modal";
import {ActivatedRoute} from "@angular/router";
import {DOCUMENT} from "@angular/platform-browser";
import {ionicConfig} from "../../../environments/ionic2.config";
import {RestaurantService} from "../../shared/services/restaurant/restaurant.service";


@Component({
  selector: 'table-form',
  templateUrl: 'table-form.component.html',
  styleUrls: ['table-form.component.css'],
  providers:[Modal],
})
export class TableFormComponent implements OnInit {
  statuses: string[] = ['Cleaning','Serving','Empty','Waiting','Reserved'];
  table:Table;

  form:FormGroup;

  @Input()
  initialValues:any;

  selectedStatus:string;
  selectorIsClicked:boolean;
  private restaurantId:string;
  private myPath:string;
   isCreating: boolean;
   currentRestaurantName: string;
  private tableId: any;
   qrCode:any;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private restaurantservice:RestaurantService,
    public modal: Modal,
    overlay: Overlay,
    vcRef: ViewContainerRef,
    @Inject(DOCUMENT) private document,

  ) {
    this.form = this.formBuilder.group({
      tableName:['',[Validators.required]],
      seats:['',[Validators.required,Validators.pattern('^(0|[1-9][0-9]*)$')]],
      isActive:[false, Validators.pattern(('true'))],
      status:['',Validators.required]
    });



    this.selectorIsClicked = false;

    overlay.defaultViewContainer = vcRef;

  }

  ngOnInit() {

    // console.log(this.initialValues);

    this.selectedStatus = this.initialValues.status;
    this.form.controls['isActive'].setValue(this.initialValues.isActive);

    let myRoute = this.route.snapshot;

    this.myPath = myRoute.url[0].path;


    this.isCreating = this.myPath === 'create';
    if (this.isCreating){


      this.select("Empty");
      this.form.controls['isActive'].setValue(true);
      this.restaurantId = myRoute.params['id'];

    } else {

      this.tableId = myRoute.params['id'];
      this.restaurantId = this.initialValues.restaurant_id;

    }


    let base = ionicConfig.host + ionicConfig.port+ '/'+ ionicConfig.iniURL + '?t=' + this.tableId;

    this.qrCode = base;

  const rRestaurant$ = this.restaurantservice.getRestaurantByKey(this.restaurantId);
    rRestaurant$
      .subscribe((restaurant)=>{this.currentRestaurantName = restaurant.restaurant});


  }


  messageIt(titleP:string,messageP:string){

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }

  print(form,code:string){
      let popupWinindow
      let myTableName = form.tableName;
      let myCode = document.getElementsByClassName("qrcode");
      // console.log(myCode);
      let ijmage = myCode[0].innerHTML;
      popupWinindow = window.open('', '_blank', 'width=1500,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
      popupWinindow.document.open();
      popupWinindow.document.write(`
          <html>
            <head>
            <style media="screen" type="text/css">


            </style>
           </head>
           <body  style="" onload="window.print()"> 
           <div style="padding-top: 25px;text-align: center">
            <div style="font-size: smaller; margin-top: -5px">
              To call for service use your favorite QR <br> 
            Scanner</div><br>
              <label> Table `+ myTableName +`</label><br><br>
              `+ ijmage +`
              
           </div>
           </body></html>`);
      popupWinindow.document.close();


  }


  printOpening() {

  }

  printClosing() {

    this.selectorIsClicked = true;
  }

  clicked(){

    this.selectorIsClicked = true;
  }

  select(selectedStatus:string) {

    this.selectedStatus = selectedStatus;
    this.form.controls['status'].setValue(selectedStatus);

  }


  itHaveErrors(){

    const isValid = this.form.valid;

    return isValid;

  }


  showSelectorError(){
    const showError = this.selectedStatus == "Select a status" && this.selectorIsClicked;

    return showError;
  }


  ngOnChanges(changes:SimpleChanges){

    if (this.form && changes['initialValues']){
      this.form.patchValue(changes['initialValues'].currentValue);
    }

  }


  isErrorVisible(field:string,error:string){

    return this.form.controls[field].dirty && this.form.controls[field].errors && this.form.controls[field].errors[error];

  }

  reset() {
    this.form.reset();
  }

  get valid(){
    return this.form.valid;
  }

  get value(){
    return this.form.value;
  }


  showErrors(){

    for (let element in this.form.controls){
      for(let element1 in  this.form.controls[element].errors){
        this.form.controls[element].markAsDirty();
      }
    }
    if (this.selectedStatus === "Select a status"){
      this.selectorIsClicked = true;
      this.form.controls['status'].markAsDirty();
    }

  }


  setBlank(){

    this.form.reset();
    this.selectedStatus = this.initialValues.status;
    this.form.controls['isActive'].setValue(true);
    this.selectorIsClicked = false;
  }



}



// WEBPACK FOOTER //
// ./src/app/table/table-form/table-form.component.ts